import React, { useState, useEffect } from "react";
import HeaderPage from "../HeaderFooter/header";
import FooterPage from "../HeaderFooter/footer";
import API_BASE_URL from "../../../apiconfig";
import { useNavigate } from "react-router-dom";

function ForgotPassword() {

	const navigate = useNavigate();
	const [step, setStep] = useState(1);
	const [username, setUsername] = useState("");
	const [otp, setOtp] = useState("");
	const [generatedOtp, setGeneratedOtp] = useState("");
	const [otpVerified, setOtpVerified] = useState(false);

	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	const [captcha, setCaptcha] = useState("");
	const [userCaptcha, setUserCaptcha] = useState("");
	const [captchaVerified, setCaptchaVerified] = useState(false);

	const [alertData, setAlertData] = useState(null);

	// 🔹 CAPTCHA
	const generateCaptcha = () => {
		const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
		let result = "";
		for (let i = 0; i < 5; i++) {
			result += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		setCaptcha(result);
	};

	useEffect(() => {
		generateCaptcha();
	}, []);

	// 🔹 OTP DEMO
	const handleSendOtp = async () => {

		// 🔹 Validation
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		const mobileRegex = /^\d{10}$/;

		if (!username || username.trim() === "") {
			setAlertData({
				message: "Please enter Email or Mobile ❗",
				type: "error",
				id: Date.now()
			});
			return;
		}

		if (!emailRegex.test(username) && !mobileRegex.test(username)) {
			setAlertData({
				message: "Enter valid Email or 10-digit Mobile ❗",
				type: "error",
				id: Date.now()
			});
			return;
		}

		try {
			const res = await fetch(
				`${API_BASE_URL}/API/Student/FORGOT_PASSWORD_SEND_OTP?username=${username}`,
				{
					method: "POST"
				}
			);

			const data = await res.text();

			if (res.ok) {
				setAlertData({
					message: data || "OTP sent successfully ✅",
					type: "success",
					id: Date.now()
				});

				// 👉 move to OTP step
				setStep(2);

			} else {
				setAlertData({
					message: data || "Failed to send OTP ❌",
					type: "error",
					id: Date.now()
				});
			}

		} catch (err) {
			setAlertData({
				message: "Server error ❌",
				type: "error",
				id: Date.now()
			});
		}
	};

	const handleVerifyOtp = async () => {

		if (!otp || otp.trim() === "") {
			setAlertData({
				message: "Please enter OTP ❗",
				id: Date.now()
			});
			return;
		}

		try {
			const res = await fetch(
				`${API_BASE_URL}/API/Student/FORGOT_PASSWORD_VERIFY_MOBILE_OTP?mobile=${username}&otp=${otp}`,
				{
					method: "POST"
				}
			);

			const data = await res.text();

			if (res.ok) {
				setOtpVerified(true);
				setStep(3);

				setAlertData({
					message: data || "OTP Verified ✅",
					type: "success",
					id: Date.now()
				});



			} else {
				setAlertData({
					message: data || "Invalid OTP ❌",
					id: Date.now()
				});
			}

		} catch (err) {
			setAlertData({
				message: "Server error ❌",
				id: Date.now()
			});
		}
	};

	const handleResetPassword = async () => {

		if (!validatePassword()) return;

		if (!captchaVerified) {
			setAlertData({
				message: "Please verify CAPTCHA ❗",
				id: Date.now()
			});
			return;
		}

		try {
			const response = await fetch(`${API_BASE_URL}/API/Student/RESET_PASSWORD`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify({
					username: username,          // your state variable
					newPassword: newPassword     // your state variable
				})
			});

			const result = await response.json();

			if (result.status === "success") {
				setAlertData({
					message: "Password reset successfully ✅",
					type: "success",   // 🔥 ADD THIS
					id: Date.now()
				});

				setTimeout(() => {
					navigate("/ASTU_JMEE_JLEE/Login");
				}, 1500);
			} else {
				setAlertData({
					message: result.message || "Something went wrong ❌",
					type: "error",     // 🔥 optional but good practice
					id: Date.now()
				});
			}

		} catch (error) {
			console.error("Error:", error);
			setAlertData({
				message: "Server error. Please try again later ❌",
				id: Date.now()
			});
		}
	};
	const validatePassword = () => {
		const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;

		if (!newPassword) {
			setAlertData({ message: "Enter new password ❗", id: Date.now() });
			return false;
		}

		if (!regex.test(newPassword)) {
			setAlertData({
				message: "Password must be strong (8+ chars, A-Z, a-z, 0-9, special char) ❗",
				id: Date.now()
			});
			return false;
		}

		if (newPassword !== confirmPassword) {
			setAlertData({ message: "Passwords do not match ❗", id: Date.now() });
			return false;
		}

		return true;
	};

	const handleCaptchaVerify = () => {
		if (!userCaptcha || userCaptcha.trim() === "") {
			setAlertData({ message: "Enter CAPTCHA ❗", id: Date.now() });
			return;
		}

		if (userCaptcha === captcha) {
			setCaptchaVerified(true);

			setAlertData({
				message: "Captcha Verified ✅",
				type: "success",
				id: Date.now()
			});
		} else {
			setCaptchaVerified(false);
			setAlertData({ message: "Invalid CAPTCHA ❌", id: Date.now() });
			generateCaptcha();
			setUserCaptcha("");
		}
	};

	return (
		<>
			<style>{`

			body {
				background: linear-gradient(135deg, #eef2ff, #f8f9ff);
			}

			.container {
				display: flex;
				justify-content: center;
				align-items: center;
				min-height: 80vh;
				font-family: 'Poppins', sans-serif;
			}

			.card {
				width: 100%;
				max-width: 420px;
				padding: 30px;
				border-radius: 20px;
				background: rgba(255,255,255,0.6);
				backdrop-filter: blur(12px);
				box-shadow: 0 10px 30px rgba(0,0,0,0.1);
				animation: fadeUp 0.5s ease;
			}

			@keyframes fadeUp {
				from { opacity: 0; transform: translateY(20px); }
				to { opacity: 1; transform: translateY(0); }
			}

			.title {
				text-align: center;
				font-size: 20px;
				font-weight: 700;
				margin-bottom: 20px;
				color: #4a54d1;
			}

			.progress {
				height: 6px;
				background: #eee;
				border-radius: 10px;
				margin-bottom: 20px;
				overflow: hidden;
			}

			.progress-bar {
				height: 100%;
				width: ${step * 33}%;
				background: linear-gradient(90deg, #6a5cff, #8f6bff);
				transition: 0.4s;
			}

			.input-group {
				position: relative;
				margin-bottom: 15px;
			}

			.input-group input {
				width: 100%;
				padding: 10px;
				border-radius: 10px;
				border: 1px solid #ddd;
				font-size: 13px;
			}

			.input-group input:focus {
				border-color: #6a5cff;
				outline: none;
			}

			.btn {
				width: 100%;
				padding: 10px;
				border: none;
				border-radius: 20px;
				background: linear-gradient(135deg, #6a5cff, #8f6bff);
				color: white;
				font-weight: 600;
				cursor: pointer;
				transition: 0.3s;
			}

			.btn:hover {
				transform: translateY(-2px);
				box-shadow: 0 5px 15px rgba(0,0,0,0.2);
			}

			.inline-btn {
				margin-top: 8px;
				padding: 7px 10px;
				border-radius: 10px;
				border: none;
				background: #28a745;
				color: white;
				cursor: pointer;
			}

			.captcha-box {
				display: flex;
				align-items: center;
				gap: 10px;
				margin-top: 10px;
				padding: 10px;
				background: #fafbff;
				border-radius: 10px;
			}

			.captcha-text {
				font-weight: bold;
				letter-spacing: 3px;
			}

			.refresh-btn {
				cursor: pointer;
			}

			.alert {
				position: fixed;
				top: 30%;
				left: 50%;
				transform: translateX(-50%);
				background: #ffdddd;
				padding: 10px 15px;
				border-radius: 10px;
			}

			.alert.success {
				background: #ddffdd;
				color: green;
			}
			.custom-alert {
				position: fixed;
				top: 30%;
				left: 50%;
				transform: translateX(-50%);
				display: flex;
				align-items: center;
				gap: 10px;
				min-width: 260px;
				max-width: 320px;
				padding: 12px 16px;
				border-radius: 12px;
				backdrop-filter: blur(10px);
				font-size: 13px;
				font-weight: 500;
				z-index: 9999;
				animation: slideDown 0.4s ease, fadeOut 0.4s ease 4.6s forwards;
			}

			/* ❌ ERROR */
			.custom-alert.error {
				background: rgba(255, 77, 79, 0.1);
				border: 1px solid rgba(255, 77, 79, 0.3);
				box-shadow: 0 8px 25px rgba(255, 77, 79, 0.2);
				color: #b30000;
			}

			/* ✅ SUCCESS */
			.custom-alert.success {
				background: rgba(40, 167, 69, 0.1);
				border: 1px solid rgba(40, 167, 69, 0.3);
				box-shadow: 0 8px 25px rgba(40, 167, 69, 0.2);
				color: #1e7e34;
			}

			.alert-icon {
				font-size: 16px;
			}

			@keyframes slideDown {
				from {
					opacity: 0;
					transform: translate(-50%, -60px) scale(0.95);
				}
				to {
					opacity: 1;
					transform: translate(-50%, 0) scale(1);
				}
			}

			@keyframes fadeOut {
				to {
					opacity: 0;
					transform: translate(-50%, -40px) scale(0.95);
				}
			}

			.disabled-btn {
				opacity: 0.6;
				cursor: not-allowed;
				filter: grayscale(30%);
				pointer-events: none; ❌ REMOVE THIS
			}
			.btn-disabled {
				opacity: 0.6;
				filter: blur(0.6px);   /* 🔥 blur effect */
				cursor: not-allowed;
				transform: none !important;
				box-shadow: none !important;
			}

			/* Optional: prevent hover effect */
			.btn-disabled:hover {
				transform: none;
				box-shadow: none;
			}
			.back-wrapper {
			  display: flex;
			  justify-content: flex-end;
			  margin-top: 8px;
			  padding: 0 20px;
			}

			.back-btn {
			  padding: 6px 14px;
			  font-size: 12px;
			  border-radius: 18px;
			  border: 1px solid #c5c9ff;
			  background: #f4f6ff;
			  color: #4a54d1;
			  font-weight: 500;
			  cursor: pointer;
			  transition: all 0.25s ease;
			}

			.back-btn:hover {
			  background: #6a5cff;
			  color: white;
			  border-color: #6a5cff;
			  box-shadow: 0 3px 8px rgba(0,0,0,0.12);
			}
			@media (max-width: 768px) {

			  .container {
			    padding: 15px;
			    align-items: flex-start;   /* prevent vertical squish */
			  }

			  .card {
			    max-width: 100%;
			    padding: 20px;
			    border-radius: 15px;
			  }

			  .title {
			    font-size: 18px;
			  }

			  .input-group input {
			    font-size: 14px;
			    padding: 10px;
			  }

			  .btn {
			    padding: 12px;
			    font-size: 14px;
			  }

			  .inline-btn {
			    padding: 6px 8px;
			    font-size: 12px;
			  }

			  /* 🔥 CAPTCHA FIX (important) */
			  .captcha-box {
			    flex-direction: column;
			    align-items: stretch;
			    gap: 8px;
			  }

			  .captcha-box input {
			    width: 100%;
			  }

			  .captcha-text {
			    text-align: center;
			    font-size: 16px;
			  }

			  .refresh-btn {
			    text-align: center;
			  }

			  /* 🔥 ALERT FIX */
			  .custom-alert {
			    width: 90%;
			    left: 50%;
			    transform: translateX(-50%);
			    font-size: 12px;
			  }
			}
			
			`}</style>

			<HeaderPage />
			<div className="back-wrapper">
				<button
					className="back-btn"
					onClick={() => navigate("/")}
				>
					← Back to Home
				</button>
			</div>

			<div className="container">
				<div className="card">

					<div className="title">Reset Password</div>

					<div className="progress">
						<div className="progress-bar"></div>
					</div>

					{/* STEP 1 */}
					{step === 1 && (
						<>
							<div className="input-group">
								<input
									type="text"
									placeholder="Enter Mobile"
									value={username}
									onChange={(e) => setUsername(e.target.value)}
								/>
							</div>
							<button className="btn" onClick={handleSendOtp}>
								Send OTP
							</button>
						</>
					)}

					{/* STEP 2 */}
					{step === 2 && (
						<>
							<div className="input-group">
								<input
									type="text"
									placeholder="Enter OTP"
									value={otp}
									onChange={(e) => setOtp(e.target.value)}
								/>
							</div>
							<button className="btn" onClick={handleVerifyOtp}>
								Verify OTP
							</button>
						</>
					)}

					{/* STEP 3 */}
					{step === 3 && (
						<>
							<div className="input-group">
								<input
									type="password"
									placeholder="New Password"
									value={newPassword}
									onChange={(e) => setNewPassword(e.target.value)}
								/>
							</div>

							<div className="input-group">
								<input
									type="password"
									placeholder="Confirm Password"
									value={confirmPassword}
									onChange={(e) => setConfirmPassword(e.target.value)}
								/>
							</div>

							<div className="captcha-box">
								<span className="captcha-text">{captcha}</span>

								<span
									className={`refresh-btn ${captchaVerified ? "disabled-btn" : ""}`}
									onClick={!captchaVerified ? generateCaptcha : null}
								>
									↻
								</span>

								<input
									type="text"
									placeholder="Captcha"
									value={userCaptcha}
									onChange={(e) => setUserCaptcha(e.target.value)}
									disabled={captchaVerified}
									className={captchaVerified ? "disabled-input" : ""}
								/>

								<button
									className={`inline-btn ${captchaVerified ? "disabled-btn" : ""}`}
									onClick={handleCaptchaVerify}
									disabled={captchaVerified}
								>
									{captchaVerified ? "✔ Verified" : "Verify"}
								</button>
							</div>

							<button
								className={`btn ${!captchaVerified ? "btn-disabled" : ""}`}
								disabled={!captchaVerified}
								onClick={handleResetPassword}
							>
								Reset Password
							</button>
						</>
					)}

				</div>

				{alertData && (
					<div
						className={`custom-alert ${alertData.type === "success" ? "success" : "error"
							}`}
						key={alertData.id}
					>
						<span className="alert-icon">
							{alertData.type === "success" ? "✅" : "⚠️"}
						</span>
						{alertData.message}
					</div>
				)}

			</div>

			<FooterPage />
		</>
	);
}

export default ForgotPassword;